import React from 'react';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import classNames from 'classnames/bind';
import { number } from 'prop-types';
import styles from './car-picker-tooltip.module.scss';

const classes = classNames.bind(styles);

export const CarPickerTooltip = ({ distance }) => {

  const TooltipContent = () => (
    <>
      <h3>Tell Us About Your Vehicle</h3>
      <p className={classes('car-picker-tooltip__content')}>
        Please select your year, make, and model to ensure all parts below will
        fit your vehicle.
      </p>
    </>
  );

  return (
    <Tooltip
      channel="desktop"
      closeButton
      content={<TooltipContent />}
      placement="bottom"
      visible
      distance={distance}
      maxWidth={350}
      zIndex={100}
    >
      <span className={classes('car-picker-tooltip__children')} />
    </Tooltip>
  );
};

CarPickerTooltip.propTypes = {
  distance: number
};

CarPickerTooltip.defaultProps = {
  distance: 14
};

CarPickerTooltip.displayName = 'CarPickerTooltip';
